import React from "react";
import { NavLink } from "react-router-dom";

const Features = () => (
  <section className="ls s-pb-30 s-pb-md-60 s-pb-xl-90 s-pt-60 s-pt-md-90 s-pt-xl-120 c-gutter-30 c-mb-60 surgical">
    <div className="container">
      <div className="row">
        <div className="col-sm-6 col-md-4">
          <div className="icon-box text-center">
            <div className="fs-56 color-main">
              <i className="fi flaticon-handshake"></i>
            </div>
            <h6 className="underline text-center mt-3">
            <NavLink to="/events">Community</NavLink>
            </h6>
            <p>Moving to a new country can be hard. Fortunately, you don’t have to go through it alone. <a href="#newsletter-section">Join our community</a> of like-minded students and professionals in the US, sharing experiences and helping one another thrive</p>
            <a href="#newsletter-section" className="btn btn-small btn-maincolor">
              Join Community
            </a>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="icon-box text-center">
            <div className="fs-56 color-main">
              <i className="fi flaticon-statistics"></i>
            </div>
            <h6 className="underline text-center mt-3">
            <NavLink to="/prospective-international-student">Consulting</NavLink>
            </h6>
            <p>Are you thinking about getting a U.S. degree but don’t know how to go about it? <a href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757" target="_blank">Schedule a consultation</a> with us and let us simplify the entire process for you</p>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757" target="_blank" className="btn btn-small btn-maincolor">
              Schedule a Consultation
            </a>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="icon-box text-center">
            <div className="fs-56 color-main">
              <i className="fi flaticon-pie-chart"></i>
            </div>
            <h6 className="underline text-center mt-3">
            <NavLink to="/current-international-student">Career</NavLink>
            </h6>
            <p>Are you an international student looking for an internship or a full-time job in the US? <a href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757" target="_blank">Make an appointment</a> with us to review your resume and provide you with career advice</p>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757" target="_blank" className="btn btn-small btn-maincolor">
              Make an Appointment
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="mb--30"></div>
  </section>
);

export default Features;
